"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vft_atom_1 = __importDefault(require("@tencent/vft-atom"));
var cookie_1 = __importDefault(require("@tencent/vft-common/cookie"));
var logger_1 = __importDefault(require("../utils/logger"));
var AppLogin = /** @class */ (function () {
    function AppLogin() {
    }
    // 是否登录
    AppLogin.prototype.isLogin = function () {
        return Boolean(cookie_1.default.get('vuserid') && cookie_1.default.get('vusession'));
    };
    // 获取用户信息
    AppLogin.prototype.getUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, type, userInfo, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isLogin()) {
                            return [2 /*return*/, null];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, vft_atom_1.default.invoke('getMainUserInfo')];
                    case 2:
                        _a = _b.sent(), type = _a.type, userInfo = _a.userInfo;
                        return [2 /*return*/, __assign({ type: type }, userInfo)];
                    case 3:
                        e_1 = _b.sent();
                        logger_1.default.error('[wetv-common/login/AppLogin.getUserInfo]', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    // 获取VIP信息
    // https://iwiki.woa.com/pages/viewpage.action?pageId=1841081395
    AppLogin.prototype.getPayVip = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, beginTime, endTime, others, bt, et, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, vft_atom_1.default.getPayVip()];
                    case 1:
                        _a = (_b.sent()) || {}, beginTime = _a.beginTime, endTime = _a.endTime, others = __rest(_a, ["beginTime", "endTime"]);
                        bt = /^1970/.test(beginTime) ? 0 : beginTime;
                        et = /^1970/.test(endTime) ? 0 : endTime;
                        return [2 /*return*/, __assign(__assign({}, others), { beginTime: bt, endTime: et })];
                    case 2:
                        e_2 = _b.sent();
                        logger_1.default.error('[wetv-common/login/AppLogin.getPayVip]', e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    // 打开登录
    AppLogin.prototype.openLogin = function () {
        return vft_atom_1.default.openLogin();
    };
    // 退出登录
    AppLogin.prototype.logout = function () {
        return vft_atom_1.default.logout();
    };
    // 监听登录成功事件
    AppLogin.prototype.onLogin = function (callback) {
        vft_atom_1.default.on('onActionLoginFinish', callback);
    };
    // 监听退出登录事件
    AppLogin.prototype.onLogout = function (callback) {
        vft_atom_1.default.on('onActionLogoutFinish', callback);
    };
    /**
     * 注册login初始化完成回调
     * @param {AnyFn} callback login初始化完成后执行的回调函数
     */
    AppLogin.prototype.onReady = function (callback) {
        callback();
    };
    AppLogin.prototype.init = function () {
        logger_1.default.info('[wetv-common/AppLogin.init]');
    };
    return AppLogin;
}());
exports.default = AppLogin;
